/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Card from 'shared/ui/components/Card.vue';
import Tag from 'shared/ui/components/Tag.vue';
import TemplateThumbnail from 'ui/components/webinars/TemplateThumbnail.vue';

const interactionsMap = {
    clapping: 'Claps',
    qna_enabled: 'Q&A',
    who_is_watching_enabled: 'Viewers list',
    interprefy_enabled: 'Live interpretation',
};

// Utils
import { get } from 'lodash';

const __vue_script__ = {
    name: 'WebinarTemplate',

    components: {
        Card,
        Tag,
        TemplateThumbnail,
    },

    props: {
        workspace: {
            type: Object,
            default: () => ({})
        },

        selected: {
            type: Boolean,
            default: false
        },

        selectable: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            integrations: []
        };
    },

    computed: {
        link() {
            return this.$const.ROUTE_WEBINAR_TEMPLATE.replace(':templateId', this.uuid);
        },

        uuid() {
            return get(this, 'workspace._id');
        },

        interactions() {
            const interactions = Object.entries(interactionsMap)
                .map(([k, v]) => this.workspace[k] ? v : undefined)
                .filter(Boolean);

            return interactions.join(', ');
        },

        iconImage() {
            return (this.workspace.icon && this.workspace.icon.length)
                ? this.$utils.assets.getWebinarTemplateAssetPath(this.workspace._id, 'icon')
                : undefined;
        }
    },

    created() {
        this.integrations = Object.keys(get(this, 'workspace.integrations', {}));
    },

    methods: {
        /**
         * Returns the tooltip config
         *
         * @param {String} content the tooltip string to display
         *
         * @return {Object|null} the config
         */
        getTooltipConfig(content) {
            return {
                content: content,
                delay: { show: 2000, hide: 300 }
            };
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{staticClass:"hovering webinar-template-card",attrs:{"link":_vm.link,"uid":_vm.uuid,"showBanner":false,"showHeader":true,"selected":_vm.selected},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click', { id: _vm.uuid, link: _vm.link })}},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('template-thumbnail',{attrs:{"color":_vm.workspace.brand_color,"icon-image":_vm.iconImage}})]},proxy:true},{key:"content",fn:function(){return [_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.getTooltipConfig(_vm.workspace.name)),expression:"getTooltipConfig(workspace.name)"}],staticClass:"title"},[_vm._v(_vm._s(_vm.workspace.name))]),_c('small',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.getTooltipConfig(_vm.workspace.interactions)),expression:"getTooltipConfig(workspace.interactions)"}],staticClass:"sub"},[_vm._v(_vm._s(_vm.workspace.interactions))]),_c('div',{staticClass:"footer"})]},proxy:true}])})}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "WebinarTemplate.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__